<template>
  <div id="bridge-cable" class="h-full p-10px w-full">
    <div class="w-full flex justify-between items-center mb-10px">
      <el-input v-model="keyword" class="!w-[calc(100%-80px)] mr-10px" placeholder="请输入关键词">
      </el-input>
      <el-button @click="getTree">搜索</el-button>
    </div>
    <el-tree
      :props="treeProps"
      :data="treeData"
      :default-checked-keys="defaultCheckedKeys"
      show-checkbox
      node-key="id"
      @node-click="clickNode"
      @check="checkChange"
      class="h-[calc(100%-60px)] overflow-auto !bg-transparent"
    >
    </el-tree>
  </div>
</template>
<script>
import { CableTrayApi } from '@wiz-api/tongre'
import { isJSONObj } from '../../../assets/js/scene/scene.js'
import HandoverService from '../../../service/HandoverService'

const cableTrayApi = new CableTrayApi()

export default {
  name: 'bridgeCable',
  props: {
    /** 场景id */
    sourceId: {
      type: String,
      defalut: '',
    },
    player: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    cloudRender: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      keyword: '',
      treeProps: {
        label: 'name',
        children: 'childrens',
        isLeaf: 'leaf',
      },
      treeData: [],
      defaultCheckedKeys: [],
      standardId: '',
      selectNode: null,
    }
  },
  methods: {
    async loadNode(node, resolve) {
      console.log(node, '树-----------', this.cloudRender)
      if (node.level === 0) {
        const [err, res] = await cableTrayApi.getCableTrayTree({ sceneId: this.sourceId })
        if (!err) {
          res.forEach((e) => {
            e.checked = true
          })
          this.defaultCheckedKeys = res.map((o) => {
            return o.id
          })
          resolve(res)
        }
        return
      }
      if (node.data.childrens && node.data.childrens?.length !== 0) {
        this.defaultCheckedKeys.push(
          ...node.data.childrens.map((o) => {
            return o.id
          })
        )
        return resolve(node.data.childrens)
      }
      if (!node.data.node) {
        const node1 = await this.player.Native.Node.findNode(0, {
          names: [node.data.name],
          codes: [node.data.code],
        })
        const info = node1.codes
          ? node1.codes[node.data.code]
          : node1.names
            ? node1.names[node.data.name]
            : null
        node.data.node = info.node
      }
      const res = await this.player.Native?.Node.getProperty(node.data.node, ['children'])

      const filterRes = _.filter(res, (el) => {
        el.id = el.item
        return el?.name && el?.visible
      })
      _.forEach(filterRes, async (el) => {
        if (
          isJSONObj(node.data.code) &&
          (JSON.parse(node.data.code).type === 'Root' ||
            JSON.parse(node.data.code).type === 'userData') &&
          el.itemType === 0 &&
          el.nodePtr
        ) {
          const nodeInfo = await this.player.Native.Node.getProperty(el.nodePtr, [
            'name',
            'code',
            'parent',
            'visible',
          ])
          if (nodeInfo.name) {
            el.name = nodeInfo.name
          }
          el.code = nodeInfo.code
        }
        if (node.checked) {
          this.defaultCheckedKeys.push(el.id)
        }
      })
      resolve(filterRes)
    },

    async getTree() {
      const [err, res] = await cableTrayApi.getCableTrayTree({
        sceneId: this.sourceId,
        keyWords: this.keyword,
      })
      if (!err) {
        res.forEach((e) => {
          e.checked = true
        })
        this.defaultCheckedKeys = res.map((o) => {
          return o.id
        })

        this.treeData = res
        res.forEach(async (e) => {
          const node = await this.player.Native.Node.findNode(0, {
            names: [e.name],
            codes: [e.code],
          })

          const info = node.codes ? node.codes[e.code] : node.names ? node.names[e.name] : null
          if (info) {
            this.player.Native.Node.setProperty(info.node, { visible: true })
          }
        })
      }
    },
    async clickNode(data) {
      const { eye, target, up } = JSON.parse(data.angle)
      this.player.Native.Camera.moveTo(eye, target, up, 2)
      if (!info.node) {
        const node = await this.player.Native.Node.findNode(0, {
          names: [data.name],
          codes: [data.code],
        })
        const info = node.codes ? node.codes[data.code] : node.names ? node.names[data.name] : null

        data.node = info.node
        this.selectNode = [info.node]
        this.player.Native.Node.selectNodes(this.selectNode)
      } else {
        this.selectNode = [info.node]

        this.player.Native.Node.selectNodes(this.selectNode)
      }
      const [err, res] = await HandoverService.getInfo({
        code: data.code,
        standardId: this.standardId,
      })
      this.$emit('transferEvent', {
        toCom: { code: 'ObjectInfoDyw', origin: 'HandoverObjectDyw', name: '对象信息' },
        type: 'business',
        props: data.code
          ? {
            ...res.data[0],
            standardId: this.standardId,
            openAlarmFlicker: true,
            flickerFrequency: 500,
          }
          : {
            standardId: this.standardId,
            openAlarmFlicker: true,
            flickerFrequency: 500,
            code: data.code,
          },
      })
    },
    async checkChange(data, { checkedKeys }) {
      if (!data.node) {
        const node = await this.player.Native.Node.findNode(0, {
          names: [data.name],
          codes: [data.code],
        })
        const info = node.codes ? node.codes[data.code] : node.names ? node.names[data.name] : null
        data.node = info.node
      }

      this.player.Native.Node.setProperty(data.node, { visible: checkedKeys.includes(data.id) })
    },
    async getStandardList() {
      const [err, res] = await HandoverService.getStandardList()
      if (!err && res && res.code === 0 && res.data) {
        this.standardId = res.data[0].id
      } else {
        this.standardId = ''
      }
    },
  },
  async created() {
    const root = await this.player.Native.Node.getRoot()
    await this.player.Native.Node.setProperty(root, { visible: false })
    this.getTree()
    await this.getStandardList()
  },
  async beforeDestroy() {
    const root = await this.player.Native.Node.getRoot()
    await this.player.Native.Node.setProperty(root, { visible: true })

    if (this.selectNode) {
      this.player.Native.Node.unSelectNodes(this.selectNode)
    }
  },
}
</script>

<style lang="scss" scoped>
#bridge-cable {
  background-color: transparent;
  ::v-deep .el-button {
    color: #fff !important;
  }
}

::v-deep .el-tree-node.is-expanded > .el-tree-node__children {
  display: inline;
}
</style>
